module.exports = __webpack_public_path__ + "src/assets/img/look.8353eb4f.jpg";